import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LogService, ServiceRouter } from '@pershing/pershing-core';
import { IconsServiceDefinition } from './icons-service-definition';
import { Observable } from 'rxjs';
import { NXIMISCServiceDefinition } from './nxi-misc-service.definition';

@Injectable()
export class NxiIconService  {
    private nxiRestServiceUrl: string;
    private nxiMiscServiceUrl: string;
    constructor(private http: HttpClient, private logService: LogService, private serviceRouter: ServiceRouter) {
        logService.info('IconsService : constructor Initializing');
        this.nxiRestServiceUrl = this.serviceRouter.getServiceRouteURL(IconsServiceDefinition.getInstance());
    }

    public getMessages():  Observable<any> {
        this.nxiMiscServiceUrl = this.serviceRouter.getServiceRouteURL(NXIMISCServiceDefinition.getInstance());
        return this.http.get(this.nxiMiscServiceUrl + '/miscservice/messages');
    }
    
    public isOneClickEdelEnabled(): Observable<any> {
        let timeNow = Date.now();
        let goPaperless = true;
        return this.http.get(this.nxiRestServiceUrl + '/portfolio/show-oneclick-edel' + '?isGoPaperlessRequest=' + goPaperless + '&time=' + timeNow, {responseType: 'json' });
    }
}
